module.exports = __webpack_public_path__ + "toBride1-we-b-g.057f8b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-b-g.jpg
// module id = nJ0e
// module chunks = 0